import { useState } from "react";
import axiosOrderSession from "../lib/axios/order.js";
import { useTranslation } from "react-i18next";

const useCreateOrder = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [orderSuccess, setOrderSuccess] = useState(false);
    const { t } = useTranslation();

    const placeOrder = async (orderData, onSuccess) => {
        setLoading(true);
        setError(null);

        try {

            const response = await axiosOrderSession.post("/orders", orderData);

            if (response.status >= 200 && response.status < 300) {
                setOrderSuccess(true);
                onSuccess();
            }
        } catch (err) {
            console.error("Error during order creation:", err);

            if (err.response) {
                const status = err.response.status;
                let errorMessage = t("unexpectedError");

                if (status >= 400 && status < 500) {
                    errorMessage = t("clientError", { code: status });
                } else if (status >= 500) {
                    errorMessage = t("serverError", { code: status });
                }

                setError({ message: errorMessage, code: status });
            } else if (err.request) {
                setError({ message: t("networkError"), code: null });
            } else {
                setError({ message: t("unexpectedError"), code: null });
            }
        } finally {
            setLoading(false);
        }
    };

    return { placeOrder, loading, setLoading, error, orderSuccess };
};

export default useCreateOrder;